export default {
  afterFirstEntry: 'lockedAfterFirst',
  alwaysUnlocked: 'unlocked',
  alwaysLocked: 'locked',
}
